import React , { useEffect } from 'react'; 
import storage from '../factory/StorageFactory.js';
// import '../styles/card-style.css';
import FormContainer from '../components/FormContainer.jsx';
import config from '../appconfig/config.json';
import img1 from '../images/appCancel.png'
import CusGreenBtn from '../components/CusGreenBtn.jsx';

const InvalidApplication = (props) => {

    useEffect(() => {
        window.scrollTo(0,0);
        storage.clearAll();
     }, []);

     const handleOnClick = () => {
        window.location.href = config.link.BacktoHome;
    }
 
    const handleCancel = () => {
      
        window.close();
    }

    return(
        <div className="container-fluid">
            <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h2 className='completeTitle1 mb-0'>
                        {'Oops!'}
                        </h2>
                    </div>
                </div>
            </div>
        <FormContainer>
                
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{padding:'10px'}}>
                    <img className="imgSccS1" src={img1} alt="imgScc1"></img>
                </div>
                <div style={{color:'#585858',padding:'10px',fontWeight:'500',fontSize:'1.2em'}}>
                    {'Your application has expired. Please reapply.'}
                </div>
            </div>

            <CusGreenBtn lbtxt='Apply Now' onClick={handleOnClick}  />

            <div style={{padding: "20px 0px"}}><hr className="yellowPanelLine" /></div>

            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{textAlign:'center',fontWeight:'500'}}>{'For queries, get in touch at'}<br/>{'1800-MAYBANK (1800-629 2265) or (65) 6533 5229 (Overseas) '}</div>
                </div>
            </div> 
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{textAlign:'center'}}>{'Note: You may also visit any Maybank branch to apply.'}</div>
                    <div style={{textAlign:'center'}}>
                        <a href={config.link.branchLocator} className="txtBlue fbaPSize"> {'Click here'}</a>{' for branch locator'}
                    </div>
                </div>
            </div> 

            <br/> 
        </FormContainer><br/>
        </div>
    )
}

export default InvalidApplication;